import { Breadcrumbs, Typography, Link } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { ReactComponent as HomeIcon } from 'images/icons/MediaLibrary/Home.svg';
import './Breadcrumb.scss';
import { useStores } from 'index';

export const Breadcrumb = observer(() => {
  const { breadcrumbTrail, navigateTo } = useStores().mediaLibraryStore;

  return (
    <Breadcrumbs className="file-manager-breadcrumb" separator="›">
      <Link
        className="file-manager-breadcrumb__link file-manager-breadcrumb__link--home"
        onClick={() => navigateTo('_root')}
      >
        <HomeIcon />
      </Link>

      {breadcrumbTrail.map(({ id, name }, index) => {
        const isLast = index === breadcrumbTrail.length - 1;

        return isLast ? (
          <Typography key={id} className="file-manager-breadcrumb__text">
            {name}
          </Typography>
        ) : (
          <Link
            key={id}
            className="file-manager-breadcrumb__link"
            onClick={() => navigateTo(id)}
          >
            {name}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
});
